import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createGenerationSalesMaster,
  listGenerationSalesMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 発電販売計画マスタ 新規登録 mutation hook。
 * onSuccess で listGenerationSalesMasters を invalidate してテーブルを最新化する。
 */
export function useCreateGenerationSalesMaster(): InvalidatingMutationResultFor<
  typeof createGenerationSalesMaster
> {
  return useInvalidatingMutation(createGenerationSalesMaster, [
    createConnectQueryKey({
      schema: listGenerationSalesMasters,
      cardinality: 'finite',
    }),
  ])
}
